import { useEffect, useState } from "react";
import Modal from "react-responsive-modal"
import TransactionServices from "../TransactionServices";

import FileLogDetail from "../../DataLoading/DataLoaderFileLogDetail";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function InvoiceImportLog(param: any) {
    console.log(param)

    let [fileLog, setfileLog] = useState<any[]>([]);
    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [fileLogList, setfileLogList] = useState<any>([]);
    let [fileLogTotalRow, setfileLogTotalRow] = useState(0);
    let [LoadFileStatus, setLoadFileStatus] = useState(false);
    let [invoiceSelect, setInvoiceSelect] = useState<any>([]);

    const onClose = () => { param.importLogOnChange(); }

    useEffect(() => {
        if (param?.selectInvoice) {
            setInvoiceSelect({ ...param.selectInvoice });
            apiCall();
        }
    }, [param?.selectInvoice]);

    var pagination = { pageNumber: 1, pageSize: 10 }
    const apiCall = () => {
        TransactionServices.searchImportLog(param.selectInvoice?.invoiceNum, pagination).then((res: any) => {
            fileLogTotalRow = res[0] ? res[0].totalRows : 0
            setfileLogTotalRow(fileLogTotalRow)
            setfileLogList(res)
        })
    }

    const exportDSPMapping = (e: any) => {
        var url = 'salesAnalysis/getContactMapping/' + e?.kontactCode + '/' + e?.tempIds
        window.open(url);
    }

    const onChangeLoadFile = (e: any) => {
        console.log(e)
        setLoadFileStatus(false)
    }

    const fileLogProgress = (e: any) => {
        setfileLog(e)
        setLoadFileStatus(true)
        console.log(e)
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        if (e == 1) {
            //uploadDelete(); 
            TransactionServices.deleteImportLog(deleteData).then(() => apiCall())
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    const onDeleteOpen = (values: any) => {
        deleteData = values
        setDeleteData(deleteData)

        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    }

    const retryImport = (values: any) => {
 
        TransactionServices.reUploadFile(values?.originalFileName, invoiceSelect?.invId, values?.kontactCode, values?.invoiceRef, 2).then(() => {
            apiCall();
        })
    }

    return (<>
        <div className="ws-6">
            <Modal open={param.importStatusLog} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-8 paddingCenterBox bgTransparent' }} >

                <div className="box ws-12">
                    <div className="box-header">
                        <h4 className="pull-left"><i className="fa fa-sticky-note"></i> Import status for invoice: <i >{invoiceSelect?.invoiceNum}</i> </h4>
                        <div className="toolbox pull-right">
                            <button title="Reload File Status" className="icon-btn delete" onClick={apiCall}><i className="icon-reload"></i> Refresh</button>
                        </div>
                    </div>

                    <div className="box-content">
                        <table className="newTable">
                            <thead>
                                <tr>
                                    <th >File</th>
                                    <th >Status</th>
                                    <th >Template</th>
                                    <th >Actions</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    fileLogList?.map((values: any) => {
                                        return (
                                            <tr className={Number(values?.status) === 1 ? "info" : "danger"}>
                                                <td >{values.fileName}

                                                    <a type="button" className="icon-btn edit btn-sm pull-right" target="_blank" href={values?.fileName}>
                                                        <i className="icon-download1"></i>
                                                    </a>
                                                </td>
                                                <td >{values?.description}</td>
                                                <td >{values?.tempIds}</td>
                                                <td >
                                                    <div className="width190">
                                                        <button className="icon-btn info btn-xs" title="Show Progression" onClick={() => fileLogProgress(values)}><i className="icon-info"></i></button>
                                                        <button className="icon-btn delete btn-xs" title="Delete file" onClick={() => onDeleteOpen(values)}><i className="icon-trashcan"></i></button>
                                                        {values?.tempIds && <button className="icon-btn warning btn-xs" title="Download Template Mapping Details" onClick={() => exportDSPMapping(values)}>
                                                            <i className="icon-download1"></i>
                                                        </button>}
                                                        <button className="icon-btn edit btn-xs" title="Retry import" onClick={() => retryImport(values)}><i className="icon-reload"></i></button>

                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>

                        <div className="clearfix">

                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete height35" onClick={onClose}><i className="icon-close"></i>Close</button>
                    </div>
                </div>

                {
                    (() => {

                        if (LoadFileStatus) {
                            return (<FileLogDetail onChangeLoadFile={onChangeLoadFile} open={LoadFileStatus} type={fileLog} />)
                        }

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={deleteStatus} message={"the data from this file"} onChange={deleteConfirmation} />
                        }

                    })()
                }

            </Modal>
        </div>

    </>)
}